/* eslint-disable no-console */
import { register } from 'register-service-worker';
import api from './service/api';
import store from './store';
import i18n from './i18n';
import process from 'process';

async function setFrontendVersion() {
  let hash = process.env.VUE_APP_COMMIT_HASH;
  if (!hash) {
    // TODO delete this if-case (no request needed), when we are not on openshift anymore
    const response = await api()
      .get('/COMMIT')
      .catch((err) => console.error(err));
    hash = response && response.status === 200 ? response.data : 'undefined';
  }

  localStorage.setItem('frontVersion', hash);
  window.dispatchEvent(
    new CustomEvent('frontVersion-changed', {
      detail: { frontVersion: hash },
    })
  );
  return hash;
}

(async () => {
  const HASH = await setFrontendVersion();
  let checkForUpdate = false;
  register(`${process.env.BASE_URL}service-worker.js?hash=${HASH}`, {
    ready() {
      console.info('App is being served from cache by a service worker.');
    },
    registered(reg) {
      console.info('Service worker has been registered.');
      setInterval(async () => {
        if (reg) {
          try {
            checkForUpdate = true;
            await reg.update();
          } catch (e) {
            console.error('Error checking for SW update:', e);
          }
        }
      }, 1000 * 30);
    },
    cached() {
      console.info('Content has been cached for offline use.');
    },
    updatefound() {
      console.info('New content is downloading.');
    },
    updated(reg) {
      console.info('Service worker updated.');
      const newWorker = reg.waiting;
      if (!newWorker) return;

      // dont check at init
      if (!checkForUpdate) return;
      console.info('New Version found!');
      store.commit(
        'alertbar/onAlert',
        {
          message: i18n.t('app.update.refresh'),
          color: 'warning',
        },
        { root: true }
      );
    },
    offline() {
      console.info(
        'No internet connection found. App is running in offline mode.'
      );
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
})();
